export enum StatusActiveGeneralEnum {
	Active = 1,
	Inactive = 0,
}
